/**
 * Format a number as currency with exactly 2 decimal places
 * @param value - The number to format
 * @returns Formatted string with 2 decimal places
 */
export const formatCurrency = (value: number | string | undefined | null): string => {
  const numValue = Number(value || 0);
  return numValue.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Format a number as currency with locale formatting (thousands separators) and 2 decimals
 * @param value - The number to format
 * @returns Formatted string with locale formatting
 */
export const formatCurrencyWithLocale = (value: number | string | undefined | null): string => {
  const numValue = Number(value || 0);
  return numValue.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/** Format displayed quantities without changing the value used in calculations. */
export const formatQuantity = (value: number | string | undefined | null): string => {
  const numValue = Number(value || 0);
  return numValue.toLocaleString('en-US', {
    maximumFractionDigits: 2,
  });
};

